import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "What Refactoring is, and what it isn't",
  "description": "",
  "published": "2012-04-11T00:00:00.000Z",
  "redirect_from": ["/blog/what-refactoring-is-and-what-it-isnt/swizec/4148"],
  "categories": "Code refactoring, Kent Beck, Languages, Martin Fowler, Methodologies, Programmer, Programming, Refactoring, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This post is my first test of zemanta's Blogspire, please tell me if you find this style of reblogging useful and I should do more in the future, or maybe I `}{`_`}{`should`}{`_`}{` reblog, but differently. Thanks :)`}</em></p>
    <p><img parentName="p" {...{
        "src": "/62f91e063b42764248d8a4f15baae958/_aYqOeKEM97s-TPZnWcXbwPI-AAAAAAAAAFk-kXux_iDWy8w-s1600-codeRefactoring.gif",
        "alt": "Refactoring",
        "title": "Refactoring"
      }}></img></p>
    <p>{`Nikos Maravitsas writes about `}<em parentName="p"><a parentName="em" {...{
          "href": "http://www.javacodegeeks.com/2012/04/what-refactoring-is-and-what-it-isnt.html"
        }}>{`What refactoring is and what it isn't`}</a></em>{` over at Java Code Geeks.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Sometimes a programmer will come to me and explain that they don't like the design of something and that "we're gonna need to do a whole bunch of refactoring" to make it right. Oh Oh. This doesn't sound good. And it doesn't sound like refactoring either....`}</p>
      <p parentName="blockquote"><img parentName="p" {...{
          "src": "https://blogspire.zemanta.com/pixie/ehz1WpCMTBqDdYS5VMr9hQ.57859/blog.gif",
          "alt": "We need this to understand how you use our service - you can take it out if you like. Cheers, your Blogspire team."
        }}></img></p>
    </blockquote>
    <p><em parentName="p">{`But that other guy before me was stupid! He did it wrong! All wrong! Wah wah wah ...`}</em></p>
    <p>{`Definitely something I've been guilty of throughout my coding career. Even went so far as justifying it in a blogpost where I asked `}{`_`}<a parentName="p" {...{
        "href": "http://swizec.com/blog/are-you-a-boy-scout-coder"
      }}>{`Are you a boyscout coder?`}</a>{` `}{`_`}{`The gist of my question was whether clients should be charged for refactoring work or not.`}</p>
    <p>{`More importantly, what level of refactoring work is on par for getting any work done in a foreign codebase and what's taking aesthetics too far.`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "http://en.wikipedia.org/wiki/Code_refactoring",
          "title": "Code refactoring"
        }}>{`Refactoring`}</a>{`, as originally defined by `}<a parentName="p" {...{
          "href": "http://martinfowler.com/",
          "title": "Martin Fowler"
        }}>{`Martin Fowler`}</a>{` and `}<a parentName="p" {...{
          "href": "http://en.wikipedia.org/wiki/Kent_Beck",
          "title": "Kent Beck"
        }}>{`Kent Beck`}</a>{`, is`}</p>
      <p parentName="blockquote"><em parentName="p">{`A change made to the internal structure of software to make it easier to understand and cheaper to modify without changing its observable behavior… It is a disciplined way to clean up code that minimizes the chances of introducing bugs.`}</em></p>
      <p parentName="blockquote">{`/.../`}</p>
      <p parentName="blockquote">{`Refactoring is supposed to be a practice that supports making changes to code. You refactor code before making changes, so that you can confirm your understanding of the code and make it easier and safer to put your change in.`}</p>
    </blockquote>
    <p>{`And that's the gist of it. You are allowed to refactor as much as you want so long as the outside interface doesn't change and you make the code demonstrably easier to work with in the future. I think any client would be happy to pay for making their development process cheaper.`}</p>
    <p>{`Nikos goes on to explain `}<em parentName="p">{`how`}</em>{` to refactor:`}</p>
    <blockquote>
      <p parentName="blockquote">{`Refactoring is simple. Protect yourself from making mistakes by first writing tests where you can. Make structural changes to the code in small, independent and safe steps, and test the code after each of these steps to ensure that you haven’t changed the behavior – it still works the same, just looks different.`}</p>
    </blockquote>
    <p>{`But there's a difference between refactoring things as you go, just polishing up some function names, changing a variable here and there, making things more readable. Those little things you have to get in order to make everyone's lives easier before you implement a new feature ... and changing the architecture of the whole system.`}</p>
    <blockquote>
      <p parentName="blockquote">{`“Large Scale Refactoring” changes can be ugly. They can take weeks or months (or years) to complete, requiring changes to many different parts of the code. They need to be broken down and released in multiple steps, requiring temporary scaffolding and detours, especially if you are working in short Agile sprints.`}</p>
    </blockquote>
    <p>{`This isn't refactoring!`}</p>
    <p>{`Call redesigning and/or rewriting what it is - `}<em parentName="p">{`redesigning`}</em>{`. If there's a business case for it, go ahead, if it makes sense to redesign now before things get messy, go ahead. For the sake of yourself and everyone around you, just don't do these things in the name of `}<em parentName="p">{`Refactoring.`}</em></p>
    <p>{`Don't be that guy.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/9209530/how-to-refactor-this-simple-code"
        }}>{`How to refactor this simple code`}</a>{` (stackoverflow.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.javacodegeeks.com/2012/04/what-refactoring-is-and-what-it-isnt.html"
        }}>{`What Refactoring is, and what it isn't`}</a>{` (javacodegeeks.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://css.dzone.com/articles/bullets-legacy-code"
        }}>{`Bullets for legacy code`}</a>{` (css.dzone.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://collectiveidea.com/blog/archives/2012/01/17/refactored-for-efficiency/"
        }}>{`Refactored for Efficiency`}</a>{` (collectiveidea.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=e998cd27-7776-4320-92af-ec753e607615",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      